import React, { useState, useEffect } from "react";
import * as XLSX from "xlsx";
import axios from "axios";
import ConsultantLayout from "../commonlayouts/consultantlayout"; 
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { Link, useNavigate } from 'react-router-dom';
import SampleTemplate from "../assets/documents/samplehotlist.xlsx";
import Swal from "sweetalert2";
import { AddHotList_BulkImport } from "../apiconstants/constants";
import { useCountry } from "../contexts/countrycodecontext.js";



const Addbulkhotlist = () => {
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [userGuid, setUserGuid] = useState("");
    const {selectedCountry}=useCountry();    
    const token = localStorage.getItem("jwtToken");
   const navigate= useNavigate();
    useEffect(() => {
      
      const storedUserGuid = localStorage.getItem("guid");
      if (storedUserGuid) {
        setUserGuid(storedUserGuid);
      }
    }, []);
  
    const handleFileChange = (e) => {
      setFile(e.target.files[0]);
    };
  
  let Guid="";
  const guid = localStorage.getItem("guid");
  const employerGuid = localStorage.getItem("employerGuid")
    const roleID = localStorage.getItem("roleID")

  if(roleID==3){
   Guid = employerGuid
  }
  else{
    Guid= guid
  }
    

    const email = localStorage.getItem("email")
   const handleImport = async () => {
      if (!file) {
        setError("Please select a file.");
        return;
      }
  
      setLoading(true);
      setError(null);
  
      try {
        // Read the Excel file
        const data = await file.arrayBuffer();
        const workbook = XLSX.read(data, { type: "array" });
        const worksheet = workbook.Sheets[workbook.SheetNames[0]];
        const jsonData = XLSX.utils.sheet_to_json(worksheet);
           if (jsonData.length > 50) {
      Swal.fire({
        icon: 'warning',
        title: 'Too many rows',
        text: 'You can only upload up to 50 rows at a time.',
      });
      setLoading(false);
      return; // ❌ Don't proceed to API call
    }
    
      
    const validateData = (data) => {
      for (let item of data) {
          let missingFields = [];
  
          if (!item.name) {
              missingFields.push('Name');
          }
          if (!item.phone) {
              missingFields.push('Phone Number');
          }
        
          if (!item.type) {
              missingFields.push('Type');
          }
  
          if (missingFields.length > 0) {
              Swal.fire({
                  icon: 'error',
                  title: 'Missing Required Fields',
                  text: `${missingFields.join(', ')} ${missingFields.length > 1 ? 'are' : 'is'} required!`,
              });
              setLoading(false);
              return false;
          }
      }
      return true;
  };
  
      
      
      // Perform validation before mapping
      if (validateData(jsonData)) {
        const formattedData = jsonData.map((item) => ({
          name: item.name,
          emailId: item.emailId ? item.emailId : "",
          phone: item.phone.toString(),
          company: item.company ? item.company : "",
          website: item.website ? item.website : "",
          description: item.description ? item.description : "",
          country: item.country,
          type: item.type,
          tierType:item.tierType||'Tier 2',
          createdBy: email,
          countryID:Number(selectedCountry),
          userGuid: guid
        }));
        
    
  
        const response = await axios.post(
         AddHotList_BulkImport.APIURL,
          formattedData,
          {
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${token}`,
            },
          }
        );
    if (response.data.details && response.data.details.length > 0) {
  const insertedList = response.data.details.filter(item => item.isInserted);
  const duplicateList = response.data.details.filter(item => !item.isInserted);

  Swal.fire({
    title: 'Import Summary',
    icon: insertedList.length > 0 ? 'success' : 'warning',
    html: `
      <div style="text-align:left">
        ✅ <strong>Successfully Inserted:</strong> ${insertedList.length}<br/>
        ❌ <strong>Duplicates:</strong> ${duplicateList.length}<br/><br/>
        ${insertedList.length > 0 ? '<strong>Inserted Records:</strong><br/>' + insertedList.map(i => `• ${i.emailId?.trim()} (${i.statusMessage})`).join('<br/>') + '<br/><br/>' : ''}
        ${duplicateList.length > 0 ? '<strong>Duplicate Records:</strong><br/>' + duplicateList.map(d => `• ${d.emailId?.trim()} (${d.statusMessage})`).join('<br/>') : ''}
      </div>
    `,
    confirmButtonText: 'OK'
  });
} else {
  Swal.fire({
    icon: 'info',
    title: 'No Records Inserted',
    text: response.data.message || 'No records were inserted.',
  });
}

  
        setLoading(false);
      } }catch (error) {
        console.error("Import error:", error);
        setError("Error occurred during import. Please try again.");
        setLoading(false);
      }
    };
  
    return (
      <ConsultantLayout>
        <section>
          <div className="container-fluid mt-4 pb-5">
            <div className="row">
              <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-3">
              <div style={{ display: 'flex', alignItems: 'center' }}>
  <Link to="/Employer/ListofStaffingContacts">
    <i className="fa fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px' }} aria-hidden="true"></i>
  </Link>
  <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: '0' }}>Import Staffing Contacts</h2>
</div>
              </div>
              <div className='col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-3'>
            <div style={{ float: "right" }}>
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Sample Excel</Tooltip>)}>

              <a href={SampleTemplate} download="SamplestaffingcontactslistFile.xlsx">  <button className="btn btn-primary mr-3" btn-ype="button"><i className="fa fa-download"></i></button> </a>
                 </OverlayTrigger>
             
            </div>
          </div>
            </div>
            <hr />
            <div class="card shadow-lg mt-5 p-5" style={{border:"none"}}>
                        
                        <div class="row mt-2">
              <div className="">
                <div className="" style={{ background: "#f8f8f8"}}>
                  <div className="d-flex">
                      <div >
                      <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Upload Excel File</Tooltip>)}>

                    <input type="file"  className=" form-control"onChange={handleFileChange} />
                   </OverlayTrigger> </div>
                    {error && <div className="invalid-feedback">{error}</div>}
                   
                    <button style={{marginLeft:15 }} onClick={handleImport}  className="btn btn-primary ">
                    {loading ? "Importing..." : "Import"}
                        </button>
                    
                  </div>
                 
  </div>
                </div>
  
              </div>
            </div>
          </div>
        </section>
      </ConsultantLayout>
    );
  };
  
  export default Addbulkhotlist;